export function rrTokens(scope = '.rr') {
	return `
  ${scope} {
    --ink: #08080A;
    --ink-2: #111114;
    --ink-3: #0D0D10;
    --line: rgba(255,255,255,0.12);
    --line-soft: rgba(255,255,255,0.06);
    --line-hi: rgba(255,255,255,0.12);
    --brand: #6B45FF;
    --brand-hi: #8B6AFF;
    --brand-soft: #C4B5FD;
    --brand-dim: rgba(107,69,255,0.10);
    --text: #FAFAFA;
    --text-2: #A1A1AA;
    --text-3: #8E8E96;
    --good: #30A46C;
    --good-dim: rgba(48,164,108,0.12);
    --bad: #E5484D;
    --bad-dim: rgba(229,72,77,0.10);
    --warn: #F76B15;
    --brand-glow: 0 0 0 1px rgba(107,69,255,0.3), 0 4px 16px rgba(107,69,255,0.25);
    --cta-shadow: 0 0 0 1px rgba(107,69,255,0.30), 0 4px 16px rgba(107,69,255,0.25);
    --cta-shadow-hi: 0 0 0 1px rgba(107,69,255,0.40), 0 6px 24px rgba(107,69,255,0.35);
    --halo: radial-gradient(ellipse at 50% 0%, rgba(107,69,255,0.15) 0%, transparent 65%);
    --paper: #FAFAFA;
    --paper-line: rgba(23,23,28,0.12);
    --paper-ink: #17171C;
    --paper-body: #3F3F46;
    --paper-mut: #71717A;
    --brand-paper: #5E3AD6;
    --brand-paper-hi: #4A2BB5;
    --brand-paper-dim: rgba(94,58,214,0.05);
    --brand-paper-sel: rgba(94,58,214,0.20);
    --mono: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace;
    --sans: 'Nunito Sans', -apple-system, 'Segoe UI', sans-serif;
    --display: 'Manrope', 'Nunito Sans', -apple-system, 'Segoe UI', sans-serif;
    --serif: 'Crimson Pro', Georgia, 'Iowan Old Style', 'Times New Roman', serif;
    --spring: cubic-bezier(0.16, 1, 0.3, 1);
  }`
}

export const RR_FONT_HREF =
	'https://fonts.googleapis.com/css2?family=Manrope:wght@500;600;700;800&family=Nunito+Sans:wght@400;600;700;800;900&display=swap'
